import { axios, API, SendRequest } from '@/imports-files/pages/clients/data-privacy/privacy-policy';


export class PrivacyPolicyService extends SendRequest
{
    async getPrivacyPolicy(params)
    {
        const url = API.client.privacy_policy.SHOW;
        try {
             const result = await axios.get( url,
              {
                params: params,
                headers: this.customHeaderJSON()
              },
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
            return result;
          } catch (error) {
            return error;
          }
    }

    async submitPolicy(params)
    {
        const url = API.client.privacy_policy.UPDATE;
        try {
             const result = await axios.post( url,
              params,
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
            return result;
          } catch (error) {
            return error;
          }
    }

    async generatePolicy(params)
    {
        const url = API.client.privacy_policy.GENERATE;
        try {
             const result = await axios.post( url,
              params,
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
            return result;
          } catch (error) {
            return error;
          }
    }
}